import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const NombreAlternativoSocioFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='NOM. ALTVO.' htmlFor='input-nombreAlternativoSocio' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='nombreAlternativoSocio'>
          {({ field }) => (
            <Form.InputText
              {...field}
              id='input-nombreAlternativoSocio'
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NombreAlternativoSocioFormGroup)
